import sanitizeHtml from 'sanitize-html';

import { getSrc } from "gatsby-plugin-image"

/* NAVIGATION - INTERACTION HANDLERS */
// Main Navbar - Navigation Scroll Behavior
export const scrollWithOffset = (el, offset) => {
  //console.debug('scroll el', el);
  //console.debug('scroll with offset', offset);
  const scrollToElement = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({top: scrollToElement, behavior: 'smooth'});
}

export const generateBackground = (backgroundColor, backgroundImage) => {
  //console.debug('backgroundColor, backgroundImage', {backgroundColor, backgroundImage});
  let sectionBackground
  if (backgroundImage) {
    const backgroundImageGatsbySrc = getSrc(backgroundImage);
    //console.debug('backgroundImageGatsbySrc', backgroundImageGatsbySrc);
    if (backgroundImageGatsbySrc) {
      sectionBackground = 'url('+encodeURI(backgroundImageGatsbySrc)+') top center no-repeat';
      if (backgroundColor) {
        sectionBackground = sectionBackground + ' ' + backgroundColor;
      }
    } else {
      if (backgroundImage.gatsbyLocalFile && backgroundImage.gatsbyLocalFile.publicURL) {
        sectionBackground = 'url('+encodeURI(backgroundImage.gatsbyLocalFile.publicURL)+') top center no-repeat';
        if (backgroundColor) {
          sectionBackground = sectionBackground + ' ' + backgroundColor;
        }
      } else if (backgroundImage.imageAbsoluteUrls && backgroundImage.imageAbsoluteUrls.length !== 0) {
        sectionBackground = 'url('+encodeURI(backgroundImage.imageAbsoluteUrls[0])+') top center no-repeat';
        if (backgroundColor) {
          sectionBackground = sectionBackground + ' ' + backgroundColor;
        }
      } else if (backgroundImage.urls && backgroundImage.urls.length !== 0) {
        sectionBackground = 'url('+encodeURI(backgroundImage.urls[0])+') top center no-repeat';
        if (backgroundColor) {
          sectionBackground = sectionBackground + ' ' + backgroundColor;
        }
      }
    }
  } else if (backgroundColor) {
    sectionBackground = backgroundColor;
  } else {
    sectionBackground = 'transparent'
  }
  //console.debug('sectionBackground', sectionBackground);
  return sectionBackground
}

export const generateVideoBackground = (backgroundColor, backgroundImage) => {
  //console.debug('backgroundColor, backgroundImage', {backgroundColor, backgroundImage});
  let backgroundStyle = {
    backgroundImage: null,
    backgroundColor: 'transparent'
  }
  if (backgroundImage) {
    const backgroundImageGatsbySrc = getSrc(backgroundImage);
    //console.debug('backgroundImageGatsbySrc', backgroundImageGatsbySrc);
    if (backgroundImageGatsbySrc) {
      backgroundStyle.backgroundImage = 'url('+encodeURI(backgroundImageGatsbySrc)+')';
    } else {
      if (backgroundImage.gatsbyLocalFile && backgroundImage.gatsbyLocalFile.publicURL) {
        backgroundStyle.backgroundImage = 'url('+encodeURI(backgroundImage.gatsbyLocalFile.publicURL)+')';
      } else if (backgroundImage.imageAbsoluteUrls && backgroundImage.imageAbsoluteUrls.length !== 0) {
        backgroundStyle.backgroundImage = 'url('+encodeURI(backgroundImage.imageAbsoluteUrls[0])+')';
      } else if (backgroundImage.urls && backgroundImage.urls.length !== 0) {
        backgroundStyle.backgroundImage = 'url('+encodeURI(backgroundImage.urls[0])+')';
      }
    }
    if (backgroundColor) {
      backgroundStyle.backgroundColor = backgroundColor;
    }
  } else if (backgroundColor) {
    backgroundStyle.backgroundColor = backgroundColor;
  } else {
    backgroundStyle.backgroundColor = 'transparent'
  }
  //console.debug('backgroundStyle', backgroundStyle);
  return backgroundStyle
}

export const sanitizeHtmlContent = (htmlToSanitize, selectedOptions) => {
  //console.debug('sanitizeHtmlContent', {htmlToSanitize, selectedOptions});
  let defaultOptions = {
    allowedAttributes: {
      a: [ 'href', 'name', 'target' ],
      span: ['class'],
      img: [ 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading' ]
    }
  };
  const sanitizedContent = htmlToSanitize ? sanitizeHtml(htmlToSanitize, selectedOptions ? selectedOptions : defaultOptions) : null;
  return sanitizedContent
}

export const truncateText = (string, length, end = '...') => {
  //return end
  const txt = string.replace(/<[^>]*>/g, '').split(' ').splice(0,length).join(' ');
  //console.debug('truncateText - txt', txt);
  return txt + end
}